import { BaseFieldRenderer } from './base-field-renderer';
import { CompanyNameFieldJsonData, RenderOptions } from '../../models/element-types';
import { TranslateUtils } from '../../utils/translate.utils';

export class CompanyNameFieldRenderer extends BaseFieldRenderer<CompanyNameFieldJsonData> {
    protected override get defaultData(): CompanyNameFieldJsonData {
        return {
            id: '',
            type: 'companyname',
            label: TranslateUtils.COMPANYNAME_FIELD.LABEL,
            placeholder: TranslateUtils.COMPANYNAME_FIELD.PLACEHOLDER,
            required: false,
            hiddenLabel: false,
            crmFieldData: {
                mixedType: 'ContactField',
                type: 'Text',
                systemName: 'Company',
                name: 'Company'
            }
        };
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected renderInput(fieldJsonData: CompanyNameFieldJsonData, options: RenderOptions): HTMLElement {
        const input = document.createElement('input');
        input.classList.add('input', 'default');
        input.type = 'text';
        input.maxLength = 500;

        this.applyCommonAttributes(input, fieldJsonData);

        return input;
    }
}
